// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0928d9c","885":"44a48a63"}[chunkId] + ".chunk.js";
};